export default {
	setUsername(state, username) {
		state.username = username
	},
	setRoomData(state, roomData) {
		state.roomData = roomData
		state.hasRoomData = true
	},
	setRoomPlayers(state, players) {
		state.players = players || []
	},
	setRoomVotes(state, votes) {
		state.votes = votes || []
	}
}
